var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6C8 7.39788 7.04392 8.57246 5.75 8.90549V11H6C7.10457 11 8 11.8954 8 13V17.605C6.47396 15.7375 4.51779 14.2631 2.29544 13.3106C2.19899 13.2693 2.09868 13.2498 2 13.2498V13C2 11.8954 2.89543 11 4 11H4.25V8.90549C2.95608 8.57246 2 7.39788 2 6C2 4.34315 5 2 5 2C5 2 8 4.34315 8 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.25C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25V14.895C20.474 16.7625 18.5178 18.2369 16.2954 19.1894C16.199 19.2307 16.0987 19.2502 16 19.2502V21.25H15V13C15 11.8954 14.1046 11 13 11H12.75V8.90549C14.0439 8.57246 15 7.39788 15 6C15 4.34315 12 2 12 2C12 2 9 4.34315 9 6C9 7.39788 9.95608 8.57246 11.25 8.90549V11H11C9.89543 11 9 11.8954 9 13V21.25H8V20.0592C7.96381 20.0268 7.93026 19.9904 7.9 19.95L7.18473 18.9963C5.83134 17.1918 4.0483 15.7567 2 14.8202V21.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6C22 7.39788 21.0439 8.57246 19.75 8.90549V11H20C20.9332 11 21.7171 11.6391 21.9379 12.5034C21.9248 12.5183 21.9121 12.5339 21.9 12.55L21.1847 13.5037C19.8313 15.3082 18.0483 16.7433 16 17.6798V13C16 11.8954 16.8954 11 18 11H18.25V8.90549C16.9561 8.57246 16 7.39788 16 6C16 4.34315 19 2 19 2C19 2 22 4.34315 22 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandle);
export default __webpack_public_path__ + "static/media/candle.1ec2f5d88ebba44023e03e98e9054ecf.svg";
export { ForwardRef as ReactComponent };